import { render, staticRenderFns } from "./ChartCircleTwo.vue?vue&type=template&id=245d22fe&"
import script from "./ChartCircleTwo.vue?vue&type=script&lang=js&"
export * from "./ChartCircleTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports